import { EMPTY_STRING } from '../../../constants/common'
import i18n from '../../../i18n'
import { getFileValueSize } from '../../File'
import { TableDateCell, TableTextCell, TableUserCell } from '../../Table'
import { toUserMultiValue } from '../../User'
import { DocumentDraggableTableTitleCell } from '../DocumentDraggableTableTitleCell'
import { DocumentTableRowAccess } from '../DocumentTableRowAccess'

import { DocumentsTableCellName } from './DocumentTableRow.constants'

export function renderCell({
  item,
  name,
  scrollRef,
  showSymbols,
  ...restProps
}) {
  const { [name]: value } = item

  function toCreateByValue(value) {
    if (value?.is_system) {
      return toUserMultiValue({
        ...value,
        fullname: i18n.t('System.SystemUserFullnameKey'),
      })
    }

    return value ? toUserMultiValue(value) : null
  }

  switch (name) {
    case DocumentsTableCellName.Title:
      return (
        <DocumentDraggableTableTitleCell
          {...restProps}
          item={item}
          showSymbols={showSymbols}
        />
      )
    case DocumentsTableCellName.Type:
      return <TableTextCell {...restProps} value={item.displayed_mime_type} />
    case DocumentsTableCellName.Access:
      return (
        <DocumentTableRowAccess
          {...restProps}
          scrollRef={scrollRef}
          value={item.permission_groups}
        />
      )
    case DocumentsTableCellName.Size:
      return (
        <TableTextCell
          {...restProps}
          value={value ? getFileValueSize({ value }) : EMPTY_STRING}
        />
      )
    case DocumentsTableCellName.Views:
      return <TableTextCell {...restProps} value={item.views_count} />
    case DocumentsTableCellName.Updated:
    case DocumentsTableCellName.CreatedAt:
      return <TableDateCell {...restProps} value={value} />
    case DocumentsTableCellName.CreatedBy:
      return <TableUserCell {...restProps} value={toCreateByValue(value)} />
    case DocumentsTableCellName.UpdatedBy:
      return (
        <TableUserCell
          {...restProps}
          value={value ? toUserMultiValue(value) : null}
        />
      )
    default:
      return null
  }
}
